import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { MdEdit, MdVisibility, MdDeleteForever } from "react-icons/md";
import { retailerService } from "../../Services";
import { DataService } from "../../Services/dataService";
import { Modal } from "../../Components";
import ReactPaginate from "react-paginate";
import Loader from "../../Components/Loader";
import { Form } from "react-bootstrap-v5";
import CheckAccess from "../../Function/CheckAccess";
import { toast } from "react-toastify";

let currentPage1 = 1
export const RetailerList = () => {
  const history = useHistory();
  const [listData, setListData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [loader, setLoader] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [registerdFilter, setRegisterdFilter] = useState("");
  const user_type = localStorage.getItem("user_type");

  useEffect(() => {
    getItemList();
    // eslint-disable-next-line
  }, [currentPage]);

  const getItemList = (filter) => {
    setRegisterdFilter(filter || "")
    let param = { ...pagination, page: currentPage };
    if (pagination.search) {
      param["page"] = 1;
    }
    if(filter) param.registered_retailer = filter
    setLoader(true);
    retailerService.getRetailer(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setListData(res.data);
        setPagination({ ...pagination, ...res.pagination });
      } else {
        setLoader(false);
      }
    });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  
  const handleApproveRate = (retailer_id) => {
    if (window.confirm('Are you sure you want to approve rate setup for this retailer?')) {
      DataService.post('/admin/approve_retailer_rate', { retailer_id }).then(res => {
        if (res && res.status) {
          alert('Rate setup approved successfully!');
          getItemList();
        } else {
          alert((res && res.message) || 'Failed to approve');
        }
      }).catch(() => {
        alert('An error occurred');
      });
    }
  };

  const onModalSubmit = () => {
    let postData = {
      id: isModalOpen._id,
      retailer_status:
        isModalOpen.retailer_status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    retailerService.updateRetailer(postData).then((res) => {
      if (res.status) {
        setIsModalOpen(false);
        getItemList(registerdFilter);
      }
    });
  };

  const onDeleteSubmit = () => {
    if (!isDeleteOpen?._id) return;
    setLoader(true);
    retailerService.deleteRetailer({ id: isDeleteOpen._id }).then((res) => {
      setLoader(false);
      if (res.status) {
        toast.success(res.message || "Retailer deleted successfully");
        setIsDeleteOpen(false);
        getItemList(registerdFilter);
      } else {
        toast.error(res.message || "Failed to delete retailer");
      }
    }).catch(() => {
      setLoader(false);
      toast.error("Failed to delete retailer");
    });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="mb-3 row me-1">
              <div className="col-9">
                <div className="input-group pl-3 w-25">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="search..."
                    onChange={(e) =>
                      setPagination({ ...pagination, search: e.target.value })
                    }
                    onKeyPress={(e) => e.key === "Enter" && getItemList()}
                    onKeyUp={(e) =>
                      e.key === "Backspace" &&
                      pagination.search.length <= 0 &&
                      getItemList(registerdFilter)
                    }
                  ></input>
                  <div className="input-group-prepend">
                    <button
                      className="input-group-text pointer search-btn"
                      onClick={() => getItemList(registerdFilter)}
                      style={{ backgroundColor: "#e5e4ec" }}
                    >
                      search
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-2">
              <Form.Select
                style={{height:"38px"}}
                    aria-label="Default select example"
                    onChange={(e) => getItemList(e.target.value)}
                    >
                    <option value="">All</option>
                    <option value="YES">Registered</option>
                    <option value="NO">No Registered</option>
                  </Form.Select>
              </div>
              {
                CheckAccess(2212, "add") && 
              <button
                className="btn btn-primary btn-sm w-sm waves-effect waves-light col-1"
                onClick={() => history.push("/add-retailer")}
              >
                Retailer
              </button>
              }
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Retailer Name</th>
                    {/* <th>Type of Retailer</th> */}
                    <th>Contact No.</th>
                    <th>Email</th>
                    <th>Referral Code</th>
                    <th>Store Count</th>
                    <th>Type</th>
                    <th>Registered</th>
                    <th>Rate Approval</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {listData.length > 0 &&
                    listData.map((list, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td>{list.retailer_name}</td>
                        {/* <td>Courier Retailer</td> */}
                        <td>{list.phone_number}</td>
                        <td>{list.retailer_email}</td>
                        <td>{list.referral_token}</td>
                        <td>
                          {list.store_details && list.store_details.length}
                        </td>
                        <td>{list.type}</td>
                        <td>{list.registered_retailer}</td>
                        <td>
                          {list.rate_approval_status === 'approved' ? (
                            <span className="badge rounded-pill font-size-12 bg-success">Approved</span>
                          ) : list.rate_approval_status === 'requested' ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-start' }}>
                              <span className="badge rounded-pill font-size-12 bg-warning text-dark">Requested</span>
                              <button
                                onClick={() => handleApproveRate(list._id)}
                                style={{
                                  background: '#28a745',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '4px',
                                  padding: '2px 8px',
                                  fontSize: '11px',
                                  cursor: 'pointer',
                                  fontWeight: '600'
                                }}
                              >
                                ✓ Approve
                              </button>
                            </div>
                          ) : (
                            <span className="badge rounded-pill font-size-12 bg-soft-danger">Pending</span>
                          )}
                        </td>
                        <td>
                          <span
                            className={
                              "badge rounded-pill font-size-12 pointer" +
                              (list.retailer_status === "ACTIVE"
                                ? " bg-success"
                                : " bg-soft-danger")
                            }
                            onClick={() => setIsModalOpen(list)}
                          >
                            {list.retailer_status}
                          </span>
                        </td>
                        <td>
                        {
                          CheckAccess(2212, "edit") && 
                          <MdEdit
                            className="pointer"
                            onClick={() =>
                              history.push(
                                "/edit-retailer?id=" + list._id,
                                list
                              )
                            }
                            color="#0323fe"
                            size="25px"
                          />
                        }
                        {
                          (CheckAccess(2212, "delete") || user_type === "SUPERADMIN") &&
                          <MdDeleteForever
                            className="pointer"
                            color="red"
                            size="25px"
                            onClick={() => setIsDeleteOpen(list)}
                          />
                        }
                          <MdVisibility
                            className="pointer"
                            onClick={() =>
                              history.push("/retailer-details?id=" + list._id)
                            }
                            color="#0323fe"
                            size="25px"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {listData.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {listData.length > 0 && pagination.totalRecord > pagination.limit && (
            <ReactPaginate
              previousLabel={
                <img src="assets/images/prev.svg" height={15} alt="not found" />
              }
              forcePage={currentPage - 1}
              nextLabel={
                <img src="assets/images/next.svg" height={15} alt="not found" />
              }
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={(e) => onPageChangeEvent(e)}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          )}
          {Boolean(isModalOpen) && (
            <Modal.ChangeStatus
              isOpen={Boolean(isModalOpen)}
              title="Update Status"
              message={`Are you sure want to ${
                isModalOpen.retailer_status === "ACTIVE" ? "Inactive" : "Active"
              } status ?`}
              onSubmitEvent={() => onModalSubmit()}
              handleClose={() => setIsModalOpen(false)}
            />
          )}
          {Boolean(isDeleteOpen) && (
            <Modal.DeleteItem
              isOpen={Boolean(isDeleteOpen)}
              title="Delete Retailer"
              message={`Are you sure you want to delete "${isDeleteOpen.retailer_name}" and all related data (stores, products, employees, roles, menus, and customization requests)? Jobs and invoices will be kept.`}
              onSubmitEvent={() => onDeleteSubmit()}
              handleClose={() => setIsDeleteOpen(false)}
            />
          )}
        </div>
        <Loader isShow={loader} />
      </div>
    </div>
  );
};
